import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { protectedRoute, Route as RouteProp } from "./protected";
import Login from "../pages/Auth/Login";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import NotFound from "../components/UI/NotFound";
import { AdminLayout } from "../components/Layout";

export const AppRouter = () => {
  return (
    <Suspense fallback={<div className="p-8 text-center text-slate-500">Loading application...</div>}>
      <Routes>
        <Route element={<AdminLayout />}>
          {protectedRoute
            .filter((route: RouteProp) => route.protected)
            .map((route: RouteProp) => {
              const Comp = route.component;

              return (
                <Route key={route.name} path={route.path} element={<Comp />} />
              );
            })}
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};
